export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Загрузка..."])}
      },
      "en": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading..."])}
      }
    }
  })
}
